const DEV_BB_URL = 'https://dev.barnbuddy.de'
const STAGING_BB_URL = 'https://staging.barnbuddy.de'
const PREVIEW_BB_URL = 'https://preview.barnbuddy.de'
const PROD_BB_URL = 'https://barnbuddy.de'

const DEV_PB_URL = 'https://dev.pig-brother.com'
const STAGING_PB_URL = 'https://staging.pig-brother.com'
const PREVIEW_PB_URL = 'https://preview.pig-brother.com'
const PROD_PB_URL = 'https://pig-brother.com'

const DEV_DC_URL = 'https://dev.data-collector.vetvise.com'
const STAGING_DC_URL = 'https://staging.data-collector.vetvise.com'
const PREVIEW_DC_URL = 'https://preview.data-collector.vetvise.com'
const PROD_DC_URL = 'https://data-collector.vetvise.com'

const LOCAL_URL = 'http://localhost:8080'

import i18n from '@/plugins/i18n.js'

const { t } = i18n.global
import { version } from '../../package.json'
import { branch, deployment, product } from '../../branch.json'

function getOrigin() {
  if (deployment === 'native') {
    if (product === 'barnbuddy') {
      if (branch === 'dev') return DEV_BB_URL
      if (branch === 'staging') return STAGING_BB_URL
      if (branch === 'preview') return PREVIEW_BB_URL
      return PROD_BB_URL
    } else if (product === 'pig-brother') {
      if (branch === 'dev') return DEV_PB_URL
      if (branch === 'staging') return STAGING_PB_URL
      if (branch === 'preview') return PREVIEW_PB_URL
      return PROD_PB_URL
    } else if (product === 'data-collector') {
      if (branch === 'dev') return DEV_DC_URL
      if (branch === 'staging') return STAGING_DC_URL
      if (branch === 'preview') return PREVIEW_DC_URL
      return PROD_DC_URL
    }
    return LOCAL_URL
  } else {
    return window.location.origin
  }
}

function useBranchString() {
  return branch
}

function useVersionString() {
  return `${branch}-${deployment}-${version}`
}

function isInDataCollectorMode() {
  if (getOrigin() === LOCAL_URL) return false
  return [DEV_DC_URL, STAGING_DC_URL, PREVIEW_DC_URL, PROD_DC_URL].includes(getOrigin())
}

function isPigBrother() {
  try {
    const pbUrls = [DEV_PB_URL, STAGING_PB_URL, PREVIEW_PB_URL, PROD_PB_URL]
    if (product === 'generic' && pbUrls.includes(window.location.origin)) return true
  } catch {}
  return product === 'pig-brother'
}

function useProductName(short = false) {
  if (isInDataCollectorMode()) {
    if (short) return t('product_name.dc.short')
    return t('product_name.dc.full')
  }
  if (deployment === 'native') {
    if (short) return t('product_name.bb.short')
    return t('product_name.bb.full')
  }
  if (isPigBrother()) {
    if (short) return t('product_name.pb.short')
    return t('product_name.pb.full')
  }
  if (short) return t('product_name.bb.short')
  return t('product_name.bb.full')
}

export { useBranchString, useVersionString, getOrigin, isInDataCollectorMode, isPigBrother, useProductName }
